import { Typography } from "antd";
import LinearGauge, { LinearGaugeType, ColorCodedGaugeOptions } from "./LinearGauge";
import { useMemo } from "react";
import { formatNumber } from "src/utils/formatting";
import React from "react";

const { Text } = Typography;

export interface DryingValueGaugeProps {
    dryingValue: number | null | undefined;
    label: string;
}

const DryingValueGauge : React.FC<DryingValueGaugeProps> = ({ dryingValue, label }) => {
    const dryingValueScaleData = useMemo(() => {
        return [-10, -8, -6, -4, -2, 0, 2, 4, 6, 8, 10];
    }, []);

    const colorCodedGaugeOptions : ColorCodedGaugeOptions = {
        ranges: [
            {
                start: -10,
                end: -2,
                color: "green"
            },
            {
                start: -2,
                end: 2,
                color: "white"
            },
            {
                start: 2,
                end: 10,
                color: "blue"
            }
        ]
    }

    return(
        <div style={{ width:'100%' }}>
            <div className="custom-gauge-header">
                <Text style={{ fontSize:'10.5px', fontFamily:'monospace', fontWeight: "bold" }}>{label}: {formatNumber(dryingValue, { decimalPlaces: 2 })}</Text>
            </div>
            <div className="custom-gauge-div">
                <LinearGauge
                currentValue={dryingValue}
                scaleData={dryingValueScaleData}
                colorCodedGaugeExists={true}
                colorCodedGaugeOptions={colorCodedGaugeOptions}
                type={LinearGaugeType.DryingValue}
                needleAnimationSpeed={0.05}
                inverted={true}
                />
            </div>
        </div>

    )
}

export default DryingValueGauge;
